export * from './vorlagen-sorter.component';
export * from './vorlagen-sorter.component.module';